import { apiJson } from '../shared/api/http';
import type { HelpContent, HelpEntryInput, HelpHistoryItem, HelpState } from './types';

/** Topics and What's new for the signed-in person, filtered by role on the server. */
export function fetchHelpContent(): Promise<HelpContent> {
  return apiJson('/api/help/content', { auth: true });
}

export function fetchHelpState(): Promise<HelpState> {
  return apiJson('/api/me/help-state', { auth: true });
}

/** Merges into the stored state: top-level keys replace, tours merge per tour id. */
export function patchHelpState(patch: Partial<HelpState>): Promise<HelpState> {
  return apiJson('/api/me/help-state', { auth: true, method: 'PATCH', body: patch });
}

export function createHelpEntry(input: HelpEntryInput) {
  return apiJson('/api/admin/help/entries', { auth: true, method: 'POST', body: input });
}

export function saveHelpEntry(id: string, input: HelpEntryInput) {
  return apiJson(`/api/admin/help/entries/${encodeURIComponent(id)}`, { auth: true, method: 'PUT', body: input });
}

/** An edited default goes back to the shipped text; a topic added in the panel is removed. */
export function removeHelpEntry(id: string) {
  return apiJson(`/api/admin/help/entries/${encodeURIComponent(id)}`, { auth: true, method: 'DELETE' });
}

export function fetchHelpHistory(id: string): Promise<HelpHistoryItem[]> {
  return apiJson(`/api/admin/help/entries/${encodeURIComponent(id)}/history`, { auth: true });
}

export function uploadHelpImage(file: File): Promise<{ url: string }> {
  const form = new FormData();
  form.append('file', file);
  return apiJson('/api/admin/help/images', { auth: true, method: 'POST', body: form });
}
